import { Button, Form, Input, QRCode, Radio, Select, Spin } from "antd";
import "../style.css";
import visa from "../../../../imagens/visa.png"
import discover from "../../../../imagens/discover.png"
import mastercard from "../../../../imagens/mastercard.png"
import piximag from "../../../../imagens/piximag.png"
import { formatCurrencyBR, identifyCardBrand } from "../../../../function/utilis/function";
import { toast } from "react-toastify";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

import InputMask from "react-input-mask";

const { Search } = Input;

export function Formulario({
    form,
    currentStep,
    buscarDadosCnpj,
    loadingSearchCep,
    setDadosCliente,
    dadosCliente,
    selecionarFormaPagamento,
    selectFormaPagamento,
    qrCode,
    setQrCode,
    idSolicitacao,
    servico,
    valor,
    pixCheckout,
    isPixReady,
    setFormData,
    municipiosOptions,
    mostrarIframe,
    linkCielo,
    loadingCheckout
}) {

    const [value, setValue] = useState("");

    const copyToClipboard = () => {
        if (!qrCode) {
            toast.warning("Não há código para copiar.");
            return;
        }

        const tempInput = document.createElement("textarea");
        tempInput.value = qrCode;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
    };

    const handleChange = (e) => {
        const onlyNums = e.target.value.replace(/\D/g, "");

    // limita a 11 dígitos
    if (onlyNums.length <= 11) {
      setValue(e.target.value);
    }
    };

    return (
        <>
            <Form layout="vertical" form={form} className="form-container">
                {/*PASSO 1 */}
                {currentStep === 1 && (
                    <>
                        <div className="form-step-section">
                            <Form.Item
                                label="Nome Completo"
                                name="nome"
                                rules={[{ required: true, message: "Por favor, insira o nome completo!" }]}
                            >
                                <Input placeholder="Digite o nome completo" />
                            </Form.Item>

                            <Form.Item
                                label="Email"
                                name="email"
                                
                                rules={[
                                    { required: true, message: "Por favor, insira o e-mail!" },
                                    { type: "email", message: "Digite um e-mail válido!" },
                                    { type: 'email' }
                                ]}
                            >
                                <Input placeholder="Digite o e-mail" />
                            </Form.Item>
                        </div>

                        <div className="form-step-section">
                            <Form.Item
                                label="CPF"
                                name="cpf"
                                rules={[{ required: true, message: "Por favor, insira o CPF!" }]}
                            >
                                <InputMask
                                    mask="999.999.999-99"
                                    maskChar={null}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/\D/g, "");
                                        if (onlyNums.length > 11) return;

                                        setDadosCliente((prev) => ({ ...prev, cpf: e.target.value }));
                                    }}
                                >
                                    {(inputProps) => (
                                        <Input {...inputProps} placeholder="CPF" maxLength={14} />
                                    )}
                                </InputMask>
                            </Form.Item>

                            <Form.Item
      label="Telefone"
      name="telefone"
      rules={[{ required: true, message: "Por favor, insira o telefone!" }]}
    >
      <InputMask
        mask="(99)99999-9999"
        maskChar={null}
        value={value}
        onChange={handleChange}
      >
        {(inputProps) => <Input {...inputProps} placeholder="Digite o telefone" />}
      </InputMask>
    </Form.Item>
                        </div>
                    </>
                )}

                {/*PASSO 2 */}
                {currentStep === 2 && (
                    <>

                        <div className="form-step-section-block">
                            <div className="form-group-flex">
                                <div className="form-item-wrapper-full-margin-right">
                                    <Form.Item
                                        label="CNPJ"
                                        name="cnpj"
                                        rules={[{ required: true, message: "Por favor, insira o CNPJ!" }]}
                                    >
                                        <InputMask
                                            mask="99.999.999/9999-99"
                                            onChange={(e) => {
                                                setDadosCliente((prev) => ({ ...prev, cnpj: e.target.value }));
                                            }}
                                        >
                                            {(inputProps) => (
                                                <Search
                                                    {...inputProps}
                                                    placeholder="CNPJ"
                                                    onSearch={buscarDadosCnpj}
                                                    loading={loadingSearchCep}
                                                    enterButton
                                                />
                                            )}
                                        </InputMask>
                                    </Form.Item>

                                </div>
                                <div className="form-item-wrapper-full-margin-right">
                                    <Form.Item
                                        label="Razão Social"
                                        name="razaoSocial"
                                        rules={[{ required: true, message: "Por favor, insira a Razão Social!" }]}
                                    >
                                        <Input placeholder="Razão Social" />
                                    </Form.Item>
                                </div>
                            </div>



                            <div className="address-box">
                                <div className="form-group-flex" style={{ marginRight: 5 }}>
                                    <div className="form-item-wrapper-full-margin-right">
                                        <Form.Item
                                            label="CEP"
                                            name="cep"
                                            rules={[{ required: true, message: "Por favor, insira o cep" }]}
                                        >
                                            <InputMask
                                                mask="99999-999"
                                                maskChar={null}
                                                onChange={(e) => {
                                                    const onlyNums = e.target.value.replace(/\D/g, "");

                                                    if (onlyNums.length > 9) return;

                                                    setDadosCliente((prev) => ({ ...prev, cep: e.target.value }));
                                                }}
                                            >
                                                {(inputProps) => (
                                                    <Input {...inputProps} placeholder="CEP" maxLength={9} />
                                                )}
                                            </InputMask>
                                        </Form.Item>

                                    </div>


                                    <div className="form-item-wrapper-full-margin-right">
                                        <Form.Item
                                            label="Logradouro"
                                            name="logradouro"
                                            rules={[{ required: true, message: "Por favor, digite o nome da Rua" }]}
                                        >
                                            <Input placeholder="Logradouro" />
                                        </Form.Item>
                                    </div>


                                    <div className="form-item-wrapper-small">
                                        <Form.Item
                                            label="Número"
                                            name="numero"
                                            rules={[{ required: true, message: "Por favor, digite o Número" }]}
                                        >
                                            <Input placeholder="Número" />
                                        </Form.Item>
                                    </div>
                                </div>

                                <div className="form-group-flex" style={{ marginRight: 5 }}>
                                    <div className="form-item-wrapper-full-margin-right">
                                        <Form.Item
                                            label="Bairro"
                                            name="bairro"
                                            rules={[{ required: true, message: "Por favor, digite o Bairro" }]}
                                        >
                                            <Input placeholder="Bairro" />
                                        </Form.Item>
                                    </div>

                                    <div className="form-item-wrapper-full-margin-right">
                                        <Form.Item
                                            label="Complemento"
                                            name="complemento"
                                            rules={[{ message: "Por favor, digite o Complemento" }]}
                                        >
                                            <Input placeholder="Complemento" />
                                        </Form.Item>
                                    </div>
                                </div>

                                <div className="form-group-flex" style={{ marginRight: 5 }}>
                                    <div className="form-item-wrapper-full-margin-right">
                                        <Form.Item
                                            label="Estado"
                                            name="estado"
                                            rules={[{ required: true, message: "Por favor, digite o Estado" }]}
                                        >
                                            <Input placeholder="Estado" />
                                        </Form.Item>
                                    </div>

                                    <div className="form-item-wrapper-full-margin-right">
                                        <Form.Item
                                            label="Município"
                                            name="ibgeMunicipio" 
                                            rules={[{ required: true, message: 'Selecione o município!' }]}
                                        >
                                            <Select
                                                showSearch
                                                optionLabelProp="label"
                                                onChange={(value, option) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        ibgeMunicipio: value,
                                                        cidade: option.label,
                                                    }));
                                                }}
                                                style={{ width: 200 }}
                                                placeholder="Selecione o Município"
                                                optionFilterProp="label"
                                                filterSort={(optionA, optionB) =>
                                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                }
                                                options={municipiosOptions}
                                                disabled
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/*PASSO 3 */}
                {currentStep === 3 && (
                    <>
                        {/*ESCOLHER FORMA DE PAGAMENTO */}
                        <div className="style-color-font-18-margin-b-10">
                            <strong>Escolha a forma de pagamento abaixo</strong>
                        </div>

                        <div className="select-forma-pagamento">
                            <Radio.Group onChange={selecionarFormaPagamento} value={selectFormaPagamento}>
                                {/*<Radio value={1}>
                                    <div className="radio-fp">
                                        <div className="fp-titulo-pix">
                                            <strong>PIX</strong>
                                        </div>
                                        <span>
                                            Pagamento via PIX confirmado<br /> instantaneamente.
                                        </span>
                                        <div className="fp-icone-pix">
                                            <FaPix size={20} className="pix-icon" />
                                        </div>
                                    </div>
                                </Radio>*/}

                                <Radio value={2}>
                                    <div className="radio-fp">
                                        <div className="fp-titulo-cartao">
                                            <strong>Cartão de crédito</strong>
                                        </div>
                                        <div className="fp-cartoes"> 
                                            <div className="fp-cartao">
                                                <img src={visa} className="fp-cartao-img" />
                                            </div>
                                            <div className="fp-cartao">
                                                <img src={discover} className="fp-cartao-img" />
                                            </div>
                                            <div className="fp-cartao">
                                                <img src={mastercard} className="fp-cartao-img mastercard-img" />
                                            </div>
                                        </div>
                                    </div>
                                </Radio>
                            </Radio.Group>
                        </div>

                        {/* --------------------- PIX --------------------- */}
                        {selectFormaPagamento === 1 && (
                            <div className="display-flx">
                                <div style={{ width: "100%" }}>
                                    <div className="img-pix">
                                        <img src={piximag} className="width-100-pc" />
                                    </div>

                                    <div className="title-pix"><strong>Pague de forma segura e instântanea</strong></div>
                                    <p className="sub-pix">Ao finalizar a compra, vamos te mostrar o código para <br />fazer o pagamento.</p>

                                    {/*AQUI ELE SÓ VAI APARECER QUANDO ELE CLICAR NO BOTÃO DE REALIZAR PAGAMENTO */}
                                    {qrCode && (
                                        <div>
                                            <div>Como pagar com Pix: </div>

                                            <div className="display-flex">
                                                <div className="como-fz-pix">
                                                    <ul>
                                                        <li>1. Acesse o app ou site do seu banco;</li>
                                                        <li>2. Busque a opção de pagar com Pix;</li>
                                                        <li>3. Leia o QR code ou código Pix;</li>
                                                        <li>4. Pronto! Você verá a confirmação do pagamento.</li>
                                                    </ul>
                                                </div>

                                                <div className="caixa-qr">
                                                    <div className="caixa-qr-code">
                                                        <QRCode
                                                            value={qrCode || '-'}
                                                            size={140}
                                                            color="#000000"
                                                            bgColor="#ffffff"
                                                            bordered={true}
                                                            style={{
                                                                padding: '16px',
                                                                borderRadius: '12px',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="margin-padd-10">
                                                <strong>Se preferir, você pode pagar copiando e colando o seguinte código:</strong>
                                            </div>

                                            <div className="display-flex margin-padd-10">
                                                <Input placeholder="código pix" className="input-ant-designer" value={qrCode} onChange={(e) => setQrCode(e.target.value)} />
                                                <Button onClick={copyToClipboard}>Copiar código</Button>
                                            </div>

                                            <div>
                                                {isPixReady && qrCode && (
                                                    <div className="pix-info-container">
                                                        <div className="progress-bar-container">
                                                            <div className="progress-bar"></div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="resumo-container">
                                    <div className="resumo-titulo">
                                        <strong>Resumo de valores e solicitação</strong>
                                    </div>
                                    <hr />
                                    <div className="resumo-texto"><strong>Número da Solicitação: {idSolicitacao}</strong></div>

                                    <div className="resumo-texto">
                                        <p>Serviço contratado:
                                            <strong> {servico}</strong></p>
                                    </div>
                                    <div className="resumo-texto">
                                        {qrCode ? (
                                            <>
                                                <p>Valor do pagamento: </p>
                                                <h1 style={{ color: "#5CB85C" }}>{formatCurrencyBR(valor)}</h1>
                                            </>
                                        ) : (null)}

                                    </div>

                                    <div>
                                        {qrCode ? (
                                            <div className="btn-pag-pix-disabled">Aguardando pagamento...</div>
                                        ) : (
                                            <div className="btn-pag-pix" onClick={() => pixCheckout(idSolicitacao)}>Realizar pagamento</div>
                                        )}

                                    </div>

                                    <div className="resumo-aviso">
                                        <p>
                                            Ao finalizar o pagamento, você confirma que está ciente e aceita as condições
                                            estabelecidas em nosso <strong>Termo de uso do serviço</strong> escolhido.
                                        </p>
                                    </div>
                                </div>

                            </div>
                        )}

                        {/* --------------------- CARTÃO (VISUAL) --------------------- */}
                        {selectFormaPagamento === 2 && (
                            <div className="flex-border-1-padd-10-border-radio-10">
                                {mostrarIframe && (
                                    <>
                                        {loadingCheckout ? (
                                            
                                            <>
                                            <div style={{width: "100%", display: "flex", justifyContent: "center", padding: 10, alignItems: "center"}}>
                                                <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                                            </div>
                                            </>
                                        ): (
                                        
                                        <iframe src={linkCielo} style={{ width: "100%", height: "500px", border: "none" }} />
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </>
                )}
            </Form>
        </>
    );
}
